import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable, Subject, tap } from 'rxjs';
import { IAction, IActionSubtype } from '../../../model/action.model';
import { ActionService } from 'src/app/services/action.service';
@Component({
    selector: 'app-callback-request-action-form',
    templateUrl: './callback-request-action-form.component.html',
    styleUrls: ['./callback-request-action-form.component.scss'],
})
export class CallbackRequestActionFormComponent implements OnInit {
    @Input() subFormIsLoading$: Subject<boolean>;
    @Input() form: FormGroup;
    @Input() action: IAction;

    subtypes: IActionSubtype[];
    showNewCustomerInputs = true;

    constructor(public actionService: ActionService, private fb: FormBuilder) {}

    ngOnInit(): void {
        this.loadFormData().subscribe(() => {
            this.extendFormControls();
            this.subFormIsLoading$.next(false);
        });
    }

    fieldIsValid(filedName: string): boolean {
        const newCustomer: FormGroup = this.form.controls.newCustomer as FormGroup;
        return (
            newCustomer.get(filedName).invalid &&
            (newCustomer.get(filedName).dirty || newCustomer.get(filedName).touched)
        );
    }

    private loadFormData(): Observable<any> {
        const actionId = this.form.get('actionType').value;
        return this.actionService.getSubtypes(actionId).pipe(
            tap((subtypes) => {
                this.subtypes = subtypes;
            })
        );
    }

    private extendFormControls() {
        this.form.addControl('customerId', new FormControl(this.action.customer?.id));
        this.form.addControl('subtypeId', new FormControl(this.action.subtypeId, Validators.required));
        this.form.addControl('phoneOptional', new FormControl(this.action.phoneOptional));
    }
}
